import { render, staticRenderFns } from "./CheckMorePosition.vue?vue&type=template&id=1407d9bf"
import script from "./CheckMorePosition.vue?vue&type=script&lang=js"
export * from "./CheckMorePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports